import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { FaWhatsapp } from 'react-icons/fa';

import { Header } from './components/Header';
import Footer from './components/Footer';

import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Promotion from './pages/Promotion';
import Contact from './pages/Contact';


function App() {
  return (
    <>
      <Header />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/promotion" element={<Promotion />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>

      {/* WhatsApp Floating Button */}
      <a
        href="https://wa.me/27729792961"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-4 right-4 bg-green-500 hover:bg-green-600 p-3 rounded-full shadow-lg z-50"
        aria-label="Chat on WhatsApp"
      >
        <FaWhatsapp className="w-6 h-6 text-white" />
      </a>

      <Footer />
    </>
  );
}

export default App;